import { HEX_3E4B68, HEX_66AAFF } from '@tanium/colors';
import { defineColor, Foreground1, Link } from '@tanium/react-theme-definition';

export const LinkText = Link;
export const LinkHoverText = defineColor([HEX_3E4B68, HEX_66AAFF]);
export const PrimaryButtonText = Foreground1;
export const SecondaryButtonText = Link;
